import { RateLocation } from "../rate-location/rate-location.type";
import { SurchargeType } from "../../surcharge-type/surcharge-type.model";

export class RateSurchargeBase {
  constructor(
    protected id: number,
    protected discriminator: string,
    protected surchargeType: SurchargeType,
    protected rateOriginLocations: RateLocation[],
    protected rateDestinationLocations: RateLocation[],
  ) {}

  public setId(param: number) {
    this.id = param;
  }

  public getId(): number {
    return this.id;
  }

  public getDiscriminator(): string {
    return this.discriminator;
  }

  public getSurchargeType(): SurchargeType {
    return this.surchargeType;
  }

  public getRateOriginLocations(): RateLocation[] {
    return this.rateOriginLocations;
  }

  public getRateDestinationLocations(): RateLocation[] {
    return this.rateDestinationLocations;
  }

  public isValid(): boolean {
    return !!this.getSurchargeType();
  }
}
